$( document ).ready(function() {
  var currentUrl = window.location.href;
  
// Dropdown plus for submenu
  jQuery(".mobile-menu ul li.menu-item-has-children").each(function() {
    jQuery(this).children("a").after("<span class='plus'></span>");
  });

  jQuery(".mobile-menu ul li.menu-item-has-children .plus").click(function(){    
    if(jQuery(this).next('.first-submenu').is(":visible"))
    {          
      jQuery(this).next('.first-submenu').slideUp();  
      $(this).removeClass("minus");    
    }
    else
    {      
      jQuery(this).next('.first-submenu').slideDown();
      $(this).addClass("minus");      
    }
  });    
// Dropdown arrow for submenu

//Slide Sub Menu
jQuery(".mobile-menu ul li.slide-sub-menu").each(function() {
  jQuery(this).children("a").after("<span class='arrow'></span>");
});

jQuery(".mobile-menu ul li.slide-sub-menu").each(function() { 
  if (currentUrl.includes('/no')) {
    jQuery(this).find("ul").prepend("<li class='back'>tilbake</li>");
  }
  else{
    jQuery(this).find("ul").prepend("<li class='back'>Back</li>");
    
  }
});

jQuery(".mobile-menu ul li.slide-sub-menu .arrow").click(function(){    
  jQuery(this).parents('.slide-sub-menu').addClass("is-open");
}); 

// go back
jQuery(".mobile-menu ul li.back").click(function(){
  jQuery(this).parents(".slide-sub-menu").first().removeClass("is-open");
});
//Slide Sub Menu

jQuery("#mobNavDrawerClose").click(function(){
  jQuery(".mobile-menu ul li.menu-item-has-children .plus").removeClass("minus");
  jQuery(".first-submenu").hide();
  jQuery(".first-submenu .slide-sub-menu.is-open").removeClass("is-open");
  
});
  
    
});
